import React from 'react';
import ProfileComponent from '../components/ProfileComponent';

const ProfilePage: React.FC = () => {

  return (<ProfileComponent></ProfileComponent>);
};

export default ProfilePage;
